import { graphql } from "gatsby";
import "../../../../src/data/sections-fragment";
import * as React from 'react';
export default {
  graphql,
  React
};